(function () {
  function initModules(root) {
    const section =
      root.matches && root.matches('[data-modules-section]')
        ? root
        : root.querySelector('[data-modules-section]');
    if (!section || section.dataset.modulesInit === 'true') return;
    section.dataset.modulesInit = 'true';

    const dots = section.querySelectorAll('[data-module-index]');
    const panels = section.querySelectorAll('[data-module-panel]');
    const lines = section.querySelectorAll('[data-line-index]');
    const track = section.querySelector('[data-modules-track]');
    const viewport = section.querySelector('.modules__panels-viewport');
    if (!dots.length || !track || !viewport) return;

    const sectionRoot = section.closest('.section-modules') || section;
    const mobileMq = window.matchMedia('(max-width: 1023px)');
    let currentIndex = 0;
    let isAnimating = false;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const transition = reduceMotion
      ? 'none'
      : 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)';
    const transitionMs = reduceMotion ? 0 : 450;
    const demoPauseMs = reduceMotion ? 0 : 700;

    function isVertical() {
      return mobileMq.matches;
    }

    function moveTrack(index, animate) {
      const offset = index * (isVertical() ? viewport.clientHeight : viewport.clientWidth);
      track.style.transition = animate ? transition : 'none';
      track.style.transform = isVertical()
        ? `translate3d(0, -${offset}px, 0)`
        : `translate3d(-${offset}px, 0, 0)`;
    }

    function syncDesktopViewportHeight() {
      if (isVertical()) {
        viewport.style.height = '';
        return;
      }

      let maxHeight = 0;
      panels.forEach((panel) => {
        maxHeight = Math.max(maxHeight, panel.offsetHeight);
      });
      viewport.style.height = maxHeight ? `${maxHeight}px` : '';
    }

    function activate(index, animate = true) {
      if (index < 0 || index >= panels.length) return;
      if (index === currentIndex && !isAnimating) return;
      if (isAnimating) {
        track.style.transition = 'none';
        isAnimating = false;
      }

      isAnimating = animate && !reduceMotion;

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.classList.toggle('is-complete', i < index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          panel.removeAttribute('inert');
        } else {
          panel.setAttribute('inert', '');
        }
      });

      lines.forEach((line, i) => {
        line.classList.toggle('is-active', i < index);
      });

      moveTrack(index, animate);
      currentIndex = index;

      if (isAnimating) {
        const onEnd = (event) => {
          if (event.target !== track || event.propertyName !== 'transform') return;
          track.removeEventListener('transitionend', onEnd);
          isAnimating = false;
          syncDesktopViewportHeight();
        };
        track.addEventListener('transitionend', onEnd);
      } else {
        syncDesktopViewportHeight();
      }
    }

    function onLayoutChange() {
      moveTrack(currentIndex, false);
      syncDesktopViewportHeight();
    }

    function wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    let demoObserver = null;

    async function runSwitchDemo() {
      if (section.dataset.modulesDemoDone === 'true' || panels.length < 2) return;
      section.dataset.modulesDemoDone = 'true';
      demoObserver?.disconnect();

      if (reduceMotion) return;

      activate(0, false);
      await wait(demoPauseMs);
      activate(1, true);
      await wait(transitionMs + demoPauseMs);
      activate(0, true);
    }

    activate(0, false);
    syncDesktopViewportHeight();

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.moduleIndex);
        activate(index);
      });
    });

    if ('IntersectionObserver' in window) {
      demoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) runSwitchDemo();
          });
        },
        { threshold: 0.35 }
      );
      demoObserver.observe(sectionRoot);
    } else if (!reduceMotion) {
      runSwitchDemo();
    }

    mobileMq.addEventListener('change', onLayoutChange);
    window.addEventListener('resize', onLayoutChange);
  }

  function initFeeling(section) {
    const root =
      section.matches && section.matches('[data-feeling-section]')
        ? section
        : section.querySelector('[data-feeling-section]');
    if (!root || root.dataset.feelingInit === 'true') return;
    root.dataset.feelingInit = 'true';

    const cards = root.querySelectorAll('[data-feeling-flip]');

    cards.forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.classList.remove('is-first-flip');
        btn.classList.toggle('is-flipped');
      });
    });

    const firstCard = root.querySelector('[data-feeling-first]') || cards[0];
    if (!firstCard) return;

    const reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    function runFirstContactFlip() {
      if (firstCard.dataset.firstContactDone === 'true') return;
      if (firstCard.classList.contains('is-flipped')) return;
      firstCard.dataset.firstContactDone = 'true';
      firstCard.classList.remove('is-first-flip');
      void firstCard.offsetWidth;
      firstCard.classList.add('is-first-flip');
    }

    firstCard.addEventListener('animationend', (e) => {
      if (e.animationName === 'feeling-card-first-flip') {
        firstCard.classList.remove('is-first-flip');
      }
    });

    firstCard.addEventListener('pointerenter', runFirstContactFlip, { once: true });
    firstCard.addEventListener(
      'focus',
      () => {
        runFirstContactFlip();
      },
      { once: true }
    );

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) runFirstContactFlip();
          });
        },
        { threshold: 0.4 }
      );
      io.observe(firstCard);
    } else {
      setTimeout(runFirstContactFlip, 700);
    }
  }

  function initFaq(section) {
    const items = section.querySelectorAll('.faq__item');
    items.forEach((item) => {
      const btn = item.querySelector('.faq__question');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        items.forEach((i) => i.classList.remove('is-open'));
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  function initBuilt(section) {
    const scroll = section.querySelector('.built__cards');
    const dots = section.querySelectorAll('.built__dot');
    const cards = section.querySelectorAll('.built__card');
    if (!scroll || !dots.length) return;

    function updateDots() {
      const scrollLeft = scroll.scrollLeft;
      let active = 0;
      cards.forEach((card, i) => {
        const offset = card.offsetLeft - scroll.offsetLeft;
        if (scrollLeft >= offset - card.offsetWidth / 2) active = i;
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    }

    scroll.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        cards[i]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
    updateDots();
  }

  function initRoutines(section) {
    const scroll = section.querySelector('.routines__scroll-wrap');
    const dots = section.querySelectorAll('.routines__dot');
    const cards = section.querySelectorAll('.routine-card');
    if (!scroll || !dots.length) return;

    function updateDots() {
      const scrollLeft = scroll.scrollLeft;
      let active = 0;
      cards.forEach((card, i) => {
        const offset = card.offsetLeft - scroll.offsetLeft;
        if (scrollLeft >= offset - card.offsetWidth / 2) active = i;
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    }

    scroll.addEventListener('scroll', updateDots, { passive: true });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        cards[i]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });
  }

  function initFrStickyCta() {
    const sticky = document.querySelector('[data-fr-sticky-cta]');
    if (!sticky || sticky.dataset.frStickyInit === 'true') return;
    sticky.dataset.frStickyInit = 'true';

    document.body.style.setProperty('--header-group-height', '0px');
    document.body.style.setProperty('--header-height', '0px');

    const hero = document.querySelector('.section-hero-face-reset');
    if (!hero) {
      sticky.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '0px 0px -1px 0px' }
    );

    observer.observe(hero);

    // Apply initial visibility immediately (observer may defer first callback)
    const heroRect = hero.getBoundingClientRect();
    const heroVisible = heroRect.bottom > 0 && heroRect.top < window.innerHeight;
    sticky.classList.toggle('is-visible', !heroVisible);
  }

  function initFrHeader() {
    const header = document.querySelector('[data-fr-header]');
    if (!header || header.dataset.frHeaderInit === 'true') return;
    header.dataset.frHeaderInit = 'true';

    document.body.style.setProperty('--header-group-height', '0px');
    document.body.style.setProperty('--header-height', '0px');

    let lastScrollY = window.scrollY;
    let ticking = false;
    const threshold = 12;

    function update() {
      ticking = false;
      const scrollY = window.scrollY;
      const scrollingUp = scrollY < lastScrollY;

      if (scrollY <= threshold) {
        header.classList.remove('is-hidden');
      } else if (scrollingUp) {
        header.classList.remove('is-hidden');
      } else {
        header.classList.add('is-hidden');
      }

      lastScrollY = scrollY;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    initFrStickyCta();
    initFrHeader();
    document.querySelectorAll('[data-modules-section]').forEach(initModules);
    document.querySelectorAll('[data-faq-section]').forEach(initFaq);
    document.querySelectorAll('[data-feeling-section]').forEach(initFeeling);
    document.querySelectorAll('[data-built-section]').forEach(initBuilt);
    document.querySelectorAll('[data-routines-section]').forEach(initRoutines);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target;
    if (el.querySelector('[data-fr-sticky-cta]')) initFrStickyCta();
    if (el.querySelector('[data-fr-header]')) initFrHeader();
    const modulesLayout = el.querySelector('[data-modules-section]');
    if (modulesLayout) initModules(modulesLayout);
    if (el.querySelector('[data-faq-section]')) initFaq(el);
    if (el.querySelector('[data-feeling-section]')) initFeeling(el);
    if (el.querySelector('[data-built-section]')) initBuilt(el);
    if (el.querySelector('[data-routines-section]')) initRoutines(el);
  });
})();
